import { render, staticRenderFns } from "./m-product-configurator.vue?vue&type=template&id=039cef75&scoped=true&"
import script from "./m-product-configurator.vue?vue&type=script&lang=js&"
export * from "./m-product-configurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039cef75",
  null
  
)

export default component.exports